import React, { useMemo } from 'react';
import { createFloatingParticles } from '../../utils/createFloatingParticles';
import './SeasonalEffect.css';
import './AutumnLeaves.css';

const LEAF_COUNT = 25;
const MOBILE_LEAF_COUNT = 12;

function AutumnLeaves() {
  const leaves = useMemo(
    () =>
      createFloatingParticles(LEAF_COUNT, {
        driftMin: -32,
        driftRange: 34,
        durationMin: 9,
        durationRange: 7,
      }),
    []
  );

  return (
    <div className="seasonal-effect autumn-leaves" aria-hidden="true">
      {leaves.map((leaf, index) => (
        <span
          key={leaf.id}
          className={`seasonal-particle autumn-leaf autumn-leaf--${leaf.id % 3}${index >= MOBILE_LEAF_COUNT ? ' seasonal-particle--desktop' : ''}`}
          style={{
            '--particle-size': `${leaf.size + 2}px`,
            '--particle-ratio': 1.1,
            '--start-x': `${leaf.startX}%`,
            '--delay': `${leaf.delay}s`,
            '--duration': `${leaf.duration}s`,
            '--drift': `${leaf.drift}vw`,
            '--spin': `${leaf.spin}deg`,
            '--particle-opacity': leaf.opacity,
          }}
        />
      ))}
    </div>
  );
}

export default AutumnLeaves;
